import React from "react";
import { translate } from "react-i18next";
import groupImg from "../../assets/media/revised/somwang_use_daycash.png";

function StepProvide({ t }) {
	return (
		<div>
			{/* 4 step */}
			<section>
				<div className="container">
					<div className="row">
						<div className="col-xs-12">
							<h2 className="gradient-txt">{t("steps_title")}</h2>
						</div>
					</div>
					<div className="row">
						<div className="col-md-3 col-xs-12 flex-center">
							<div className="step-block item1">
								1<br />
								<br />
								<p>{t("steps_title1")}</p>
								<div className="arrow-right"></div>
								<div className="arrow-down"></div>
							</div>
						</div>
						<div className="col-md-3 col-xs-12 flex-center">
							<div className="step-block item2">
								2<br />
								<br />
								<p>{t("steps_title2")}</p>
								<div className="arrow-right"></div>
								<div className="arrow-down"></div>
							</div>
						</div>
						<div className="col-md-3 col-xs-12 flex-center">
							<div className="step-block item3">
								3<br />
								<br />
								<p>{t("steps_title3")}</p>
								<div className="arrow-right"></div>
								<div className="arrow-down"></div>
							</div>
						</div>
						<div className="col-md-3 col-xs-12 flex-center">
							<div className="step-block item4">
								4<br />
								<br />
								<p>{t("steps_title4")}</p>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* IMG */}
			<figure style={{ margin: "4rem 0" }}>
				<div style={{ backgroundColor: "#fff" }} className="container">
					<img className="center-img" src={groupImg} alt="" />
				</div>
			</figure>
			{/* Daycash provide */}
			<section>
				<div className="container">
					<div className="row">
						<div className="col-xs-12">
							<h2 className="gradient-txt">{t("provide_cashflow_title")}</h2>
						</div>
						<div className="col-md-4">
							<div className="topic-wrapper">
								<h3 className="help-topic-title">
									{t("provide_cashflow_title1")}
								</h3>
								<p>{t("provide_cashflow_desc1")}</p>
								<p>{t("provide_cashflow_desc1_1")}</p>
							</div>
						</div>
						<div className="col-md-4">
							<div className="topic-wrapper">
								<h3 className="help-topic-title">
									{t("provide_cashflow_title2")}
								</h3>
								<p>{t("provide_cashflow_desc2")}</p>
							</div>
							<div className="topic-wrapper">
								<h3 className="help-topic-title">
									{t("provide_cashflow_title3")}
								</h3>
								<p>{t("provide_cashflow_desc3")}</p>
							</div>
						</div>
						<div className="col-md-4">
							<div className="topic-wrapper">
								<h3 className="help-topic-title">
									{t("provide_cashflow_title4")}
								</h3>
								<p>{t("provide_cashflow_desc4")}</p>
							</div>
							<div className="topic-wrapper">
								<h3 className="help-topic-title">
									{t("provide_cashflow_title5")}
								</h3>
								<p>{t("provide_cashflow_desc5")}</p>
							</div>
						</div>
					</div>
				</div>
			</section>
			{/* 3 step */}
			<section>
				<div className="container">
					<div className="row">
						<div className="col-xs-12">
							<h2 className="gradient-txt">{t("emp_step_title")}</h2>
						</div>
					</div>
					<div className="row">
						<div
							style={{ flexDirection: "column" }}
							className="col-md-4 col-xs-12 flex-center"
						>
							<div className="step-block item1">
								1<br />
								<br />
								<p>{t("emp_step_title1")}</p>
								<div className="arrow-right alt"></div>
								<div className="arrow-down alt"></div>
							</div>
							<span>{t("emp_step_sub1")}</span>
						</div>
						<div
							style={{ flexDirection: "column" }}
							className="col-md-4 col-xs-12 flex-center"
						>
							<div className="step-block item2">
								2<br />
								<br />
								<p>{t("emp_step_title2")}</p>
								<div className="arrow-right alt"></div>
								<div className="arrow-down alt"></div>
							</div>
							<span>{t("emp_step_sub2")}</span>
						</div>
						<div
							style={{ flexDirection: "column" }}
							className="col-md-4 col-xs-12 flex-center"
						>
							<div className="step-block item3">
								3<br />
								<br />
								<p>{t("emp_step_title3")}</p>
							</div>
							<span>{t("emp_step_sub3")}</span>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
}

export default translate("translations")(StepProvide);



// WEBPACK FOOTER //
// ./src/components/home/StepProvide.jsx